export const ONBOARDING_KEY_PREFIX = 'visibeen.onboardingComplete:';

const fallbackKey = 'visibeen.onboardingComplete.global';

export const extractUserId = (user) => {
  if (!user || typeof user !== 'object') return null;
  return (
    user.id ??
    user.user_id ??
    user.userId ??
    user.customer_id ??
    user?.user?.id ??
    user?.user?.user_id ??
    user?.data?.id ??
    null
  );
};

export const getOnboardingStorageKey = (user) => {
  const userId = extractUserId(user);
  return userId ? `${ONBOARDING_KEY_PREFIX}${userId}` : fallbackKey;
};

export const hasCompletedOnboarding = (user) => {
  if (typeof window === 'undefined') return false;
  const key = getOnboardingStorageKey(user);
  return localStorage.getItem(key) === 'true';
};

export const markOnboardingComplete = (user) => {
  if (typeof window === 'undefined') return;
  const key = getOnboardingStorageKey(user);
  localStorage.setItem(key, 'true');
};

const interpretBooleanFlag = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1 ? true : value === 0 ? false : undefined;
  if (typeof value === 'string') {
    const normalized = value.toLowerCase();
    if (['true', '1', 'yes', 'y'].includes(normalized)) return true;
    if (['false', '0', 'no', 'n'].includes(normalized)) return false;
  }
  return undefined;
};

export const shouldShowOnboarding = (user) => {
  if (!user) return false;
  const completionFlag = hasCompletedOnboarding(user);
  if (completionFlag) return false;

  const possibleFlags = [
    user.is_new_user,
    user.isNewUser,
    user.isNew,
    user.onboarding_completed,
    user.onboardingCompleted,
    user.has_completed_onboarding,
    user.hasCompletedOnboarding,
    user?.user?.is_new_user,
    user?.user?.isNewUser,
  ];

  for (const flag of possibleFlags) {
    const interpreted = interpretBooleanFlag(flag);
    if (interpreted === false) return false;
    if (interpreted === true) return true;
  }

  // If no explicit flag is provided, fall back to showing the flow once per user
  return !completionFlag;
};
